import {createNoise3D} from 'simplex-noise'
import {store} from '../store'
import {vec2, rotate2D} from "./core.js"

export default class Cell {
  constructor(options) {
    options = options ? options : {};
    let h = window.innerHeight
    this.center = options.center ? options.center : vec2(h*.5,h*.5)
    this.palette = options.palette? options.palette : 0
    this.radius = !options.radius ? 50 : options.radius;
    this.oblongness = !options.oblongness
      ?  Math.random()+0.75
      : options.oblongness;
    this.angle = !options.angle ? Math.random()*Math.PI*2. : options.angle; 
    this.complexity = !options.complexity ? 0.25 : options.complexity;
    this.resolution = !options.resolution ? 150 : options.resolution;
    this.primaryColor =  options.primaryColor
    this.secondaryColor = options.secondaryColor
    this.edgeColor =  options.edgeColor
    this.vertices = [];
    this.indices = [];
    this.colors = [];
    this.numLayers = 3;
    this.id = Math.floor(Math.random() * 9999)
    this.createVertices();
    this.createIndices();
  }

  toP5Color(color){
    //254 because of weird alpha bug in P5
    return store.p5.color(color.r,color.g,color.b,254)
  }

  createVertices() {
    let noise = createNoise3D()
    this.vertices.push(this.center);
    this.colors.push(this.primaryColor); 
    for (let j = 0; j < this.numLayers; j++) {
      let val = this.secondaryColor;
      if (j == 0) {
        val = this.primaryColor; 
      }
      if (j == this.numLayers - 1) {
        val = this.edgeColor; 
      }
      for (let i = 0; i < this.resolution; i++) {
        let LAYER = j+1
        this.colors.push(val);
        let step = (i / this.resolution) * Math.PI * 2;
        let r = this.radius * LAYER;
        let nx = this.complexity;
        nx = parseFloat(store.P5Instance.map(j,this.numLayers,0,this.complexity,0))
        let n = noise(
          Math.cos(step)*nx+LAYER*this.id,
          Math.sin(step)*nx+LAYER*this.id,
          LAYER*this.id) *0.5 + 0.5
        let extrude = this.complexity * 2
        r += n * ((this.radius*0.25)*LAYER*extrude);
        let x = Math.cos(step) * r + this.center.x
        let y = Math.sin(step) * (r*this.oblongness) + this.center.y
        let v= rotate2D(this.center.x,this.center.y,x,y,this.angle);
        this.vertices.push(v)
      } 
    } 
  } 

  createIndices() {
    for (let layer = 0; layer < this.numLayers; layer++) {
      for (let i = 0; i < this.resolution; i++) {
        if (layer == 0) {
          this.indices.push(0);
          this.indices.push(i + 1);
          this.indices.push(((i + 1) % this.resolution) + 1);
        } else {
          this.indices.push(i + 1 + this.resolution * (layer - 1));
          this.indices.push(i + 1 + this.resolution * layer);
          this.indices.push(
            ((i + 1) % this.resolution) + 1 + this.resolution * layer
          );

          this.indices.push(i + 1 + this.resolution * (layer - 1));
          this.indices.push(
            ((i + 1) % this.resolution) + 1 + this.resolution * layer
          );
          this.indices.push(
            ((i + 1) % this.resolution) + 1 + this.resolution * (layer - 1)
          );
        }
      }
    }
  }
}

